import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { supabase } from '../../lib/supabase'
import '../onboarding/onboarding.css'
import './settings.css'

const DEACTIVATE_MESSAGE = 'Are you sure you want to deactivate your account? All your data (profile, photos, chats, messages, likes) will be permanently deleted and cannot be recovered. Any active subscription will be cancelled. You will no longer be able to access the account.'

const NETLIFY_FUNCTIONS = import.meta.env.VITE_NETLIFY_FUNCTIONS_URL || ''

const SettingsAccount = () => {
  const navigate = useNavigate()
  const { user } = useAuth()
  const [showDeactivateModal, setShowDeactivateModal] = useState(false)
  const [deactivating, setDeactivating] = useState(false)
  const [deactivateError, setDeactivateError] = useState('')

  const onBack = () => navigate('/app/profile/settings')
  const onChangePassword = () => navigate('/app/profile/settings/account/change-password')
  const onDeactivate = () => {
    setDeactivateError('')
    setShowDeactivateModal(true)
  }
  const cancelDeactivate = () => setShowDeactivateModal(false)
  const confirmDeactivate = async () => {
    if (!user) return
    setDeactivating(true)
    setDeactivateError('')
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const token = session?.access_token
      const url = NETLIFY_FUNCTIONS ? `${NETLIFY_FUNCTIONS}/deactivate-account` : '/.netlify/functions/deactivate-account'
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        }
      })
      const body = await res.json().catch(() => ({}))
      if (!res.ok) {
        setDeactivateError(body.error || 'Deactivation failed')
        setDeactivating(false)
        return
      }
      await supabase.auth.signOut()
      navigate('/', { replace: true })
      window.location.reload()
    } catch (e) {
      console.error(e)
      setDeactivateError('Deactivation failed')
      setDeactivating(false)
    }
  }

  return (
    <div className="onboarding-page">
      <div className="onboarding-content" style={{ paddingTop: 48, paddingBottom: 80 }}>
        <div style={{ marginBottom: 24 }}>
          <button type="button" className="link" onClick={onBack}>← Back</button>
        </div>
        <h1 className="h1">Account & password</h1>
        <button type="button" className="settings-list-item" style={{ width: '100%' }} onClick={onChangePassword}>
          Change password
        </button>
        <button
          type="button"
          className="settings-list-item"
          style={{ width: '100%', color: 'var(--red, #c00)' }}
          onClick={onDeactivate}
        >
          Deactivate account
        </button>
      </div>

      {showDeactivateModal && (
        <div className="settings-modal-overlay" onClick={cancelDeactivate}>
          <div className="settings-modal" onClick={(e) => e.stopPropagation()}>
            <p className="p" style={{ marginBottom: 24 }}>{DEACTIVATE_MESSAGE}</p>
            {deactivateError && <p className="p" style={{ color: 'var(--red, #c00)', marginBottom: 12 }}>{deactivateError}</p>}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <button type="button" className="settings-modal-btn settings-modal-btn-secondary" onClick={cancelDeactivate}>
                Cancel
              </button>
              <button
                type="button"
                className="settings-modal-btn settings-modal-btn-danger"
                onClick={confirmDeactivate}
                disabled={deactivating}
              >
                {deactivating ? 'Deactivating…' : 'Deactivate account'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default SettingsAccount
